import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const DesignEditorPreviewContent = ({ className, children, ...props }) => {
  const classes = classNames({
    'design-editor-preview-content': true,
    [className]: !!className,
  });

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

DesignEditorPreviewContent.propTypes = propTypes;

export default DesignEditorPreviewContent;
